import { getTransportTrackingLink } from "helpers/utils";
import React from "react";
import { Button, UncontrolledTooltip } from "reactstrap";

const getRefCode = (data, isTrackingTransport) => {
  if (data.transport_tracking_url && isTrackingTransport) {
    return (
      <>
        <Button id={`ref_code_link_${data.id}`} size="sm" color="link">
          <a
            href={getTransportTrackingLink(
              data.transport_tracking_url,
              data.ref_code
            )}
            target="_blank"
            rel="noreferrer"
            style={{
              color: "inherit",
            }}
          >
            {data.ref_code}
          </a>
        </Button>
        <UncontrolledTooltip
          placement="top"
          target={`ref_code_link_${data.id}`}
        >
          Tracking đơn
        </UncontrolledTooltip>
      </>
    );
  }

  return data.ref_code;
};

const RefCode = ({
  t,
  ref_code,
  data,
  isAllowUpdateRefCode,
  onUpdateRefCode,
  isAllowUpdateExistRefCode,
  onUpdateExistRefCode,
  isTrackingTransport = true,
}) => {
  return ref_code ? (
    <div className="d-flex align-items-center gap-1">
      {getRefCode(data, isTrackingTransport)}
      <Button
        id={`ref_code_copy_${data.id}`}
        size="sm"
        color=""
        className="bg-light"
        onClick={e => navigator.clipboard.writeText(ref_code)}
      >
        <i className="far fa-copy fa-md text-secondary" />
      </Button>
      <UncontrolledTooltip placement="top" target={`ref_code_copy_${data.id}`}>
        Copy
      </UncontrolledTooltip>
      {isAllowUpdateExistRefCode && (
        <>
          <Button
            size="sm"
            id={`ref_code_edit_${data.id}`}
            onClick={onUpdateExistRefCode}
            className="bg-light"
            color=""
          >
            <i className="fas fa-pen fa-md text-warning" />
          </Button>
          <UncontrolledTooltip
            placement="top"
            target={`ref_code_edit_${data.id}`}
          >
            Cập nhật
          </UncontrolledTooltip>
        </>
      )}
    </div>
  ) : (
    <a
      href="#"
      style={{
        cursor: isAllowUpdateRefCode ? "pointer" : "default",
      }}
      className={isAllowUpdateRefCode ? "text-danger" : "text-warning"}
      onClick={e => {
        if (!isAllowUpdateRefCode) {
          return;
        }
        onUpdateRefCode();
      }}
    >
      {t("order:form.no_information")}
    </a>
  );
};

export default RefCode;
